import { TDocumentDefinitions } from "pdfmake/interfaces";

import { intoCareDocument } from "./document";
import { DocumentContext } from "./document-context";
import { footer } from "./footer";
import { card, descriptionItem, divider, section } from "./generic";
import { questionnaireContent, questionnaireScoringContent } from "./questionnaire";
import { residentSection } from "./resident";
import { shortTime } from "./utils";
import { SubmittedAssessmentReportData } from "../reports/types";

export const getSubmittedAssessmentDefinition = (
	ctx: DocumentContext,
	data: SubmittedAssessmentReportData,
	user?: string,
): TDocumentDefinitions => {
	const creationDate = new Date(data.submittedAssessment.createdOn);

	const topHeaderText = ctx.t("features/pdf-generation.header.topHeader", {
		creator: data.submittedAssessment.createdBy.label,
		creationDate: creationDate.toLocaleDateString(ctx.locale),
		creationTime: creationDate.toLocaleTimeString(ctx.locale, shortTime),
	});

	return intoCareDocument(ctx, {
		info: {
			title: `${data.assessmentTitle} - ${data.resident.lastName} ${data.resident.firstName} - ${creationDate.toLocaleDateString(ctx.locale)}`,
			author: user ?? data.submittedAssessment.createdBy.label,
		},
		content: [
			[
				{ text: data.assessmentTitle, style: "header" },
				{ text: topHeaderText, style: "topHeader" },
			],
			divider(),
			residentSection(ctx, {
				title: ctx.t("domain-model.submittedAssessment.property.resident.label"),
				resident: data.resident,
			}),
			divider(),
			section({
				title: ctx.t("domain-model.submittedAssessment.property.details.label"),
				content: {
					columnGap: 12,
					columns: [
						{
							width: "*",
							stack: descriptionItem({
								term: ctx.t("domain-model.submittedAssessment.property.notes.label"),
								content: data.submittedAssessment.notes ?? "-",
							}),
						},
						{
							width: "auto",
							alignment: "right",
							stack: descriptionItem({
								term: ctx.t("domain-model.submittedAssessment.property.includeInBriefing.label"),
								content: data.submittedAssessment.includeInBriefing
									? ctx.t("domain-codes.boolean.TRUE.display")
									: ctx.t("domain-codes.boolean.FALSE.display"),
							}),
						},
					],
				},
			}),
			card({
				content: questionnaireScoringContent(ctx, data),
			}),
			section({
				title: ctx.t("domain-model.submittedAssessment.property.questionnaire.label"),
				content: questionnaireContent(data),
			}),
		],
		footer: () => {
			return user !== undefined ? footer(ctx, user) : undefined;
		},
	});
};
